var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { createContext, useEffect, useMemo } from 'react';
import { useLoader } from './loader';
import { loaderComponentConfig } from './loader-config';
import { useAppSelector } from '../../../components/app/hooks';
export var LoaderContext = createContext({});
export var LoaderWrapper = function (_a) {
    var identifier = _a.identifier, onLoadingChange = _a.onLoadingChange, _b = _a.children, children = _b === void 0 ? React.createElement("div", null) : _b, _c = _a.type, type = _c === void 0 ? 'default' : _c, _d = _a.loadingDisabled, loadingDisabled = _d === void 0 ? false : _d, _e = _a.customLoader, customLoader = _e === void 0 ? null : _e, _f = _a.loaderComponentProps, loaderComponentProps = _f === void 0 ? {} : _f, _g = _a.loaderContainerProps, loaderContainerProps = _g === void 0 ? {} : _g, props = __rest(_a, ["identifier", "onLoadingChange", "children", "type", "loadingDisabled", "customLoader", "loaderComponentProps", "loaderContainerProps"]);
    var loaderObj = useLoader({ identifier: identifier });
    var isLoaderEnabled = useAppSelector(function (state) { return state.loadingStore.isLoaderEnabled; });
    var isLoading = useMemo(function () { return loaderObj === null || loaderObj === void 0 ? void 0 : loaderObj["".concat(identifier, "IsLoading")]; }, [loaderObj === null || loaderObj === void 0 ? void 0 : loaderObj["".concat(identifier, "IsLoading")]]);
    useEffect(function () {
        onLoadingChange === null || onLoadingChange === void 0 ? void 0 : onLoadingChange(loaderObj === null || loaderObj === void 0 ? void 0 : loaderObj["".concat(identifier, "IsLoading")]);
    }, [isLoading]);
    var Component = useMemo(function () {
        var _Component = loaderComponentConfig[type];
        var obj = {};
        if (!isLoaderEnabled)
            return children;
        if (customLoader && !(!isLoading || loadingDisabled))
            return customLoader;
        if (props && identifier)
            return (React.createElement(_Component, __assign({ customLoader: customLoader, isLoading: !(!isLoading || loadingDisabled) }, props, obj, { loaderContainerProps: loaderContainerProps, loaderComponentProps: loaderComponentProps, Component: React.cloneElement(children ? children : React.createElement("div", null), {
                    isLoading: !(!isLoading || loadingDisabled || !isLoaderEnabled),
                }) })));
        else
            return React.createElement(React.Fragment, null);
    }, [type, isLoading, children]);
    return (React.createElement(LoaderContext.Provider, { value: { isLoading: !(!isLoading || loadingDisabled || !isLoaderEnabled) } }, Component));
};
